
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REFURBISH_DEVICE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { refurbishDeviceResult } from 'Redux/actions';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* refurbishDevice({ payload }) {
    try {

        const { id } = payload
        let QUERY = `     
            mutation createRefurbishedUnit ($id: Int!) {
              result: createRefurbishedUnit (id: $id) {
                    unitId
                    esn
                    imei
                    refurbishedUnitId
                    
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: id
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(refurbishDeviceResult(data?.result))

    } catch (exc) {
        yield put(refurbishDeviceResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/refurbishDevice/redux/saga",
            "refurbishDevice", true)
    }
}

function* watchMethods() {
    yield takeEvery(REFURBISH_DEVICE_REQUEST, refurbishDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}